export default "__VITE_ASSET__922d5055__"